import {
  createRoutesFromChildren,
  matchRoutes,
  Routes,
  useLocation,
  useNavigationType,
} from "react-router-dom";
import {
  initializeFaro as coreInit,
  getWebInstrumentations,
  ReactIntegration,
  ReactRouterVersion,
} from "@grafana/faro-react";
import type { Faro } from "@grafana/faro-react";
import { TracingInstrumentation } from "@grafana/faro-web-tracing";

interface InitializeOptions {
  apikey?: string;
  name?: string;
  url?: string;
  enabled?: boolean,
  version?: string;
  environment?: string;
}

const InitializeOptionsDefaults: InitializeOptions = {
  url: "https://gap01.ltvops.com/collect",
  environment: "default",
  version: "0.0.0",
  enabled: true
};
export function initialize(options = InitializeOptionsDefaults): Faro {

  const currentOptions = { ...InitializeOptionsDefaults, ...options };
  currentOptions.apikey = process.env['REACT_APP_APM_KEY'] ? process.env['REACT_APP_APM_KEY'] : currentOptions.apikey
  const apmEnabled = process.env['REACT_APP_APM_ENABLED'] ? process.env['REACT_APP_APM_ENABLED'] : 'true'
  if (['yes','true','t','y'].indexOf(apmEnabled) !==-1){
    currentOptions.enabled = true
  }
  if (
    currentOptions.apikey === "" ||
    currentOptions.apikey === undefined ||
    !currentOptions
  ) {
    throw new Error("No APM Key Provided")
  }
  const targetUrl =currentOptions.url === "" || currentOptions.url === undefined? InitializeOptionsDefaults.url : currentOptions.url
  const faro = coreInit({
    url: targetUrl,
    apiKey: currentOptions.apikey,
    instrumentations: [
      ...getWebInstrumentations({
        captureConsole: true,
      }),
      new TracingInstrumentation(),
      new ReactIntegration({
        router: {
          version: ReactRouterVersion.V6,
          dependencies: {
            createRoutesFromChildren,
            /* @ts-ignore */
            matchRoutes,
            Routes,
            useLocation,
            useNavigationType,
          },
        },
      }),
    ],
    session: (window as any).__PRELOADED_STATE__?.faro?.session,
    app: {
      name: options.name,
      version: options.version,
    },
  });
  return faro;
}


